import * as e from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/TextAlignLeft.es.js";
const t = e.forwardRef((o, r) => /* @__PURE__ */ e.createElement(n, { ref: r, ...o, weights: a }));
t.displayName = "TextAlignLeftIcon";
const m = t;
export {
  m as TextAlignLeft,
  t as TextAlignLeftIcon
};
